import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import dayjs from 'dayjs';

interface ReopenedChipProps {
  reopenedAt?: string | null;
  size?: 'small' | 'medium';
}

/**
 * Tag shown on any task that was completed and later reopened.
 */
const ReopenedChip: React.FC<ReopenedChipProps> = ({ reopenedAt, size = 'small' }) => {
  if (!reopenedAt) return null;

  const when = dayjs(reopenedAt).isValid()
    ? dayjs(reopenedAt).format('MMM D, YYYY h:mm A')
    : '';

  return (
    <Tooltip title={when ? `Reopened ${when}` : 'This task was reopened after completion'}>
      <Chip
        label="Reopened"
        size={size}
        sx={{
          height: size === 'small' ? 20 : 24,
          fontSize: size === 'small' ? '0.65rem' : '0.75rem',
          fontWeight: 600,
          bgcolor: '#4F46E5',
          color: '#ffffff',
        }}
      />
    </Tooltip>
  );
};

export default ReopenedChip;
